/** 控制台 · 我的素材页（pages/console/assets.tsx）与上传流程（lib/upload.ts）。 */
const messages = {
  'page.title': '我的素材',
  'page.description': '上传图片、视频、音频后，在任务的 inputs 中用素材 ID 引用。',
  'page.import': 'URL 导入',
  'page.upload': '上传文件',

  cancel: '取消',
  save: '保存',
  saved: '已保存',
  saveFailed: '保存失败',
  delete: '删除',
  deleteFailed: '删除失败',
  'validation.max64': '最多 64 个字符',
  'validation.nameRequired': '请填写名称',

  'storage.label': '存储空间',
  'storage.aria': '存储空间已用 {pct}%',
  'storage.almostFull': '空间快满了，删除不用的素材可释放空间。',

  'group.nameRequired': '请填写分组名',
  'group.renamed': '已重命名',
  'group.created': '分组已创建',
  'group.renameTitle': '重命名分组',
  'group.createTitle': '新建分组',
  'group.dialogDescription': '分组只用于整理素材，不影响任务调用。',
  'group.nameLabel': '分组名',
  'group.deleted': '分组已删除',
  'group.deleteTitle': '删除分组“<name/>”？',
  'group.deleteBody': '只能删除空分组。分组里还有素材时，请先把素材移到其他分组或删除。',
  'group.navAria': '素材分组',
  'group.heading': '分组',
  'group.create': '新建分组',
  'group.all': '全部素材',
  'group.menuAria': '{name} 的操作',
  'group.rename': '重命名',
  'group.delete': '删除分组',
  'group.loadError': '分组加载失败',
  'group.none': '未分组',

  'upload.cancelAria': '取消上传 {name}',
  'upload.retryAria': '重试 {name}',
  'upload.removeAria': '移除 {name}',
  'upload.progressAria': '{name} 上传进度',
  'upload.queued': '等待上传',
  'upload.done': '已上传，平台正在处理',
  'upload.failed': '上传失败',
  'upload.requestId': '（请求 ID {id}）',
  'upload.activeTitle': '正在上传 {n} 个文件',
  'upload.failedTitle': '{n} 个文件上传失败',
  'upload.completeTitle': '上传完成',
  'upload.clearFinished': '清除已完成',
  'upload.emptyFile': '{name} 是空文件，已跳过',
  'upload.tooLarge': '{name} 超过 2 GB，已跳过',
  'upload.error.storageStatus': '文件上传失败（存储返回 HTTP {status}），请重试。',
  'upload.error.network': '上传中断，请检查网络后重试。',
  'upload.error.aborted': '上传已取消',
  'upload.error.noUrl': '上传地址缺失，请重试。',
  'upload.error.noEtag': '存储未返回分片校验值（ETag），无法完成分片上传。',

  'import.urlInvalid': '请输入完整的 http(s) 地址',
  'import.urlProtocol': '只支持 http 或 https 地址',
  'import.urlTooLong': '地址过长',
  'import.nameRequired': '请填写素材名',
  'import.started': '已开始导入',
  'import.startedDescription': '平台拉取并保存成功后，素材会变为可用。',
  'import.title': '从 URL 导入',
  'import.description': '平台从这个地址拉取文件。只有拉取并保存成功后，素材才会长期保存。',
  'import.error': '导入失败',
  'import.urlLabel': '文件地址',
  'import.urlDescription': '支持 http/https；必须是公网可访问的地址。',
  'import.nameLabel': '素材名',
  'import.trustLabel': '素材类型',
  'import.trustDescription': '含真人面部的素材需要完成真人授权后才能使用。',
  'import.submit': '开始导入',

  'table.name': '名称',
  'table.kind': '类型',
  'table.spec': '规格',
  'table.size': '大小',
  'table.status': '状态',
  'table.createdAt': '创建时间',

  'preview.loadError': '预览加载失败',

  'sheet.fallbackTitle': '素材详情',
  'sheet.loading': '加载中',
  'sheet.deleteRequested': '已申请删除',
  'sheet.deleteRequestedDescription': '仍被进行中的任务引用时，会在任务结束后清理。',
  'sheet.alert.failed': '素材不可用',
  'sheet.alert.authorization': '需要完成真人授权',
  'sheet.alert.note': '状态说明',
  'sheet.alert.authorizationBody': '这个素材是真人人像，本人完成下方的真人认证后才能用于生成。',
  'sheet.alert.failedBody': '请更换文件后重新上传。',
  'sheet.status': '状态',
  'sheet.id': '素材 ID',
  'sheet.trust': '素材类型',
  'sheet.mime': '格式',
  'sheet.size': '大小',
  'sheet.dimensions': '尺寸',
  'sheet.duration': '时长',
  'sheet.version': '版本',
  'sheet.channels': '渠道就绪',
  'sheet.channelsReady': '已同步到 {n} 条处理线路',
  'sheet.channelsPending': '尚未同步，首次使用时自动同步',
  'sheet.createdAt': '创建时间',
  'sheet.name': '名称',
  'sheet.group': '分组',
  'sheet.delete': '删除素材',
  'sheet.deleteTitle': '删除“<name/>”？',
  'sheet.deleteBody': '删除后不可恢复，新任务不能再引用它。仍被进行中的任务引用时，会在任务结束后清理。',

  'roles.title': '素材在任务里怎么用',
  'roles.intro': '上传一次，提交任务时按 ID 引用，同一素材可在多个任务中重复使用。',
  'roles.first.role': '首帧',
  'roles.first.body': '首帧生成：视频从这张图开始往下拍。',
  'roles.firstLast.role': '首帧 + 尾帧',
  'roles.firstLast.body': '首尾帧生成：给出开头和结尾两张，中间的过渡交给模型。',
  'roles.reference.role': '参考图 / 视频 / 音频',
  'roles.reference.body': '多模态参考：用几份素材定下质感、动作或声音，再用提示词描述镜头。',
  'roles.alt': '示意画面：{role}',
  'roles.sampleNote': '示意画面，由程序生成，并非 Seedance 输出。',

  'drop.toGroup': '松开即可上传到“<name/>”',
  'drop.toLibrary': '松开即可上传到素材库',

  'section.aria': '素材',
  'search.placeholder': '按名称或素材 ID 搜索',
  'search.aria': '搜索素材',
  'filter.kindAria': '素材类型',
  'filter.allKinds': '全部',
  'filter.statusAria': '素材状态',
  'filter.allStatuses': '全部状态',
  'view.aria': '显示方式',
  'view.grid': '网格',
  'view.list': '列表',

  'meta.group': '分组“<name/>”',
  'meta.loaded': '第 {page} 页 · 本页 <n>{count}</n> 个',

  'list.loadError': '素材加载失败',
  'empty.clearFilters': '清除筛选',
  'empty.filtered': '没有符合条件的素材，换个关键词或清除筛选条件。',
  'empty.group': '这个分组还没有素材。',
  'empty.library': '还没有素材。',
  'empty.hint': '把文件拖到这里，或点击右上角上传；文生视频不需要素材。',

  limits:
    '图片单张 ≤ {imageMax}、边长 {minSide}–{maxSide} px；视频单个 ≤ {videoMax}、{minSec}–{maxSec} 秒；音频单个 ≤ {audioMax}。不符合模型要求的素材在提交任务时会被拒绝。',
  'portrait.title': '真人认证',
  'portrait.description': '请本人用手机扫码完成刷脸认证。认证按模型生效，换模型需要再认证一次。',
  'portrait.verifiedFor': '已认证：{models}',
  'portrait.model': '选择模型',
  'portrait.start': '开始认证',
  'portrait.noModels': '还没有开通任何模型，开通后才能认证。',
  'portrait.continue': '继续认证',
  'portrait.already': '这个模型已经认证过，可以直接使用。',
  'portrait.startFailed': '无法发起认证',
  'portrait.dialogTitle': '扫码完成真人认证',
  'portrait.dialogDescription': '用于 {model}。请素材中的本人操作。',
  'portrait.qrLabel': '真人认证二维码',
  'portrait.step1': '用手机相机或微信扫描二维码',
  'portrait.step2': '按页面提示完成刷脸',
  'portrait.step3': '完成后回到这里，结果会自动更新',
  'portrait.waiting': '等待认证结果，二维码 {time} 前有效',
  'portrait.openOnThisDevice': '在本设备打开认证页',
  'portrait.done': '真人认证完成',
  'portrait.doneBody': '素材已可用于这个模型的生成任务。',
  'portrait.failedBody': '认证没有通过，可以重新发起。',
  'portrait.close': '关闭',
  'portrait.later': '稍后再说',
  'portrait.status.pending': '认证中',
  'portrait.status.verified': '已认证',
  'portrait.status.failed': '未通过',
  'portrait.status.expired': '已过期',
  'upload.moreTypes': '更多上传类型',
  'upload.as.normal': '上传为普通素材',
  'upload.as.virtual_avatar': '上传为虚拟人物',
  'upload.as.real_person': '上传为真人人像',
  'upload.hint.normal': '普通图片、视频、音频',
  'upload.hint.virtual_avatar': 'AI 生成或卡通形象，用于保持角色一致',
  'upload.hint.real_person': '本人照片，上传后需扫码刷脸认证（仅图片）',
  'upload.realPersonImagesOnly': '真人人像只支持图片，其他文件已忽略',
};

export default messages;
